import { invalidateSingleEntryCache } from 'api/urql/helpers/mutation';

export const deleteRequestor = (results, args, cache, info) => {
  // handlers go here
  invalidateSingleEntryCache('Requestor')(
    results,
    args,
    cache,
    info
  );
};
